import { render, staticRenderFns } from "./PurN.vue?vue&type=template&id=913cc2b8"
import script from "./PurN.vue?vue&type=script&lang=js"
export * from "./PurN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports